import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Agent Login API Call
 * @param {Object} credentials - { email, password }
 * @returns {Promise<Object>} - Response data from the API
 */
export const agentLoginApi = async (credentials) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.AGENT_LOGIN, credentials);
    return response.data; // Return the response data (contains token or error)
  } catch (error) {
    handleApiError(error); // Handle error with the common handler
    throw error; // Propagate the error
  }
};
